import React from "react";
import HeroSection from "@/components/blocks/HeroSection";
import ScrollReveal from "@/components/ScrollReveal";
import BrassRule from "@/components/BrassRule";

/**
 * Country page top — full-bleed hero + a centered editorial manifesto
 * (two short paragraphs from the per-country meta block).
 */
export default function CountryHero({
  meta,
  countryName,
  italicTail,
  experiencesCount,
  countLabel,
  eyebrow,
  manifestoLines,
}) {
  return (
    <>
      <HeroSection
        image={meta.image}
        imageAlt={meta.image_alt}
        eyebrow={eyebrow}
        title={countryName}
        italicTail={italicTail}
        subtitle={null}
        height="h-[78vh]"
      />

      <section className="bg-ivory">
        <div className="mx-auto max-w-3xl px-6 md:px-10 py-28 md:py-36 text-center">
          <ScrollReveal>
            <p className="eyebrow text-brass">
              {experiencesCount} {countLabel}
            </p>
          </ScrollReveal>
          <ScrollReveal delay={120}>
            <div className="mt-10 space-y-7 text-charcoal/85 text-[17px] md:text-[18px] leading-[1.9] text-pretty text-left">
              {manifestoLines.map((p, i) => (
                <p key={`m-${i}-${p.slice(0, 24)}`}>{p}</p>
              ))}
            </div>
          </ScrollReveal>
          <ScrollReveal delay={260}>
            <BrassRule className="mt-12" width={60} />
          </ScrollReveal>
        </div>
      </section>
    </>
  );
}
